<div class="card single-image-card"
    [ngClass]="{
        'skeleton': !imageLoaded
    }">
    <div class="card-body d-flex justify-content-center align-items-center">
        <div class="card-img">
            <div *ngIf="hasSketch" class="select-action-container" (click)="selectImage(true)">
                <i [ngClass]="selected ? 'fas fa-check-square' : 'far fa-square'"></i>
            </div>

            <img *ngIf="imageUrl"
                [ngClass]="{
                    'img-responsive': true,
                    'd-none': !imageUrl && !imageLoaded
                }" 
                [src]="imageUrl"
                (click)="hasSketch ? openPreview() : null"
                (load)="onImageLoad()" 
                (error)="onImageError(imageUrl)">

            <span *ngIf="!imageLoaded"
                class="loading">
                <div class="loader-icon">
                    <i class="fas fa-images"></i>
                </div>
            </span>
        </div>
    </div>
</div>

<!--<ngx-gallery *ngIf="hasSketch" [options]="optionsPreview" [images]="album" #onlyPreviewGallery></ngx-gallery>-->